import { render, staticRenderFns } from "./WorkDetail.vue?vue&type=template&id=370b4387&scoped=true&"
import script from "./WorkDetail.vue?vue&type=script&lang=ts&"
export * from "./WorkDetail.vue?vue&type=script&lang=ts&"
import style0 from "./WorkDetail.vue?vue&type=style&index=0&id=370b4387&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370b4387",
  null
  
)

export default component.exports